import React from "react";
import { cn } from "@/lib/utils";

export const StatusBadge = ({ statusMap, value, className }) => {
  const s = statusMap[value] || { label: value || "-", cls: "bg-neutral-100 text-neutral-700 border-neutral-300" };
  return (
    <span
      className={cn(
        "inline-flex items-center rounded-full border px-2 py-0.5 text-xs font-semibold whitespace-nowrap",
        s.cls,
        className,
      )}
      data-testid={`status-${value}`}
    >
      {s.label}
    </span>
  );
};
